let serverTimeOffsetMs = 0;
const TAIWAN_TIMEZONE_OFFSET = '+08:00';
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const LOCAL_DATETIME_PATTERN = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;
const TIMEZONE_PATTERN = /(Z|[+-]\d{2}:\d{2})$/i;

const toDate = (value) => {
  if (!value) { return null; }

  if (typeof value === 'string' && !TIMEZONE_PATTERN.test(value)) {
    if (DATE_ONLY_PATTERN.test(value)) {
      value = `${value}T00:00:00${TAIWAN_TIMEZONE_OFFSET}`;
    } else if (LOCAL_DATETIME_PATTERN.test(value)) {
      value = `${value.replace(' ', 'T')}${TAIWAN_TIMEZONE_OFFSET}`;
    }
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const syncServerTime = (response) => {
  const serverDateHeader = response?.headers?.date ?? response?.headers?.Date;
  const serverDate = toDate(serverDateHeader);

  if (!serverDate) { return; }

  serverTimeOffsetMs = serverDate.getTime() - Date.now();
};

export const getServerNow = () => new Date(Date.now() + serverTimeOffsetMs);

export const getRegistrationStatus = (registrationInfo, now = getServerNow()) => {
  const current = toDate(now);
  const openDate = toDate(registrationInfo?.bookingOpenDate);
  const closeDate = toDate(registrationInfo?.bookingCloseDate);

  if (!current || !openDate) { return 'closed'; }
  if (current < openDate) { return 'not-open'; }
  if (closeDate && current >= closeDate) { return 'closed'; }

  return 'open';
};

export const isRegistrationOpen = (registrationInfo, now = getServerNow()) => {
  return getRegistrationStatus(registrationInfo, now) === 'open';
};

export const isRegistrationClosed = (registrationInfo, now = getServerNow()) => {
  return getRegistrationStatus(registrationInfo, now) === 'closed';
};

export const getRegistrationUnavailableMessage = (registrationInfo, now = getServerNow()) => {
  return getRegistrationStatus(registrationInfo, now) === 'closed'
    ? '報名已截止'
    : '尚未開放報名';
};